/** Zuweisungsebene: was einem Benutzer in der Berechtigungsverwaltung gegeben wird. */
export enum RoleType {
  ProduktRead = 1,
  ProduktWrite = 2,
  StandortRead = 3,
  StandortWrite = 4,
  PartnerRead = 5,
  PartnerWrite = 6,
  AbholungRead = 7,
  AbholungWrite = 8,
  EinlieferungRead = 9,
  EinlieferungWrite = 10,
  AblieferungRead = 11,
  AblieferungWrite = 12,
  BestandRead = 13,
  BestandWrite = 14,
  Nachweis = 15,
  Nachweisverfolgung = 16,
  Cockpit = 17,
  Report = 18,
  ImportInbound = 19,
  ImportOutbound = 20,
  ZertifikatRead = 21,
  ZertifikatWrite = 22,
  BilanzRead = 23,
  BilanzWrite = 24,
  PocRead = 25,
  GenericImport = 26,
  YtdReport = 27,
  Nachweisverteilung = 28,
  MandantAllgemeinRead = 29,
  MandantAllgemeinWrite = 30,
  ZertifizierungenRead = 31,
  ZertifizierungenWrite = 32
}

/** Durchsetzungsebene: was geprüft wird; identisch zum Backend-PermissionType. */
export enum PermissionType {
  ProduktRead = 1,
  ProduktWrite = 2,
  StandortRead = 3,
  StandortWrite = 4,
  PartnerRead = 5,
  PartnerWrite = 6,
  AbholungRead = 7,
  AbholungWrite = 8,
  EinlieferungRead = 9,
  EinlieferungWrite = 10,
  AblieferungRead = 11,
  AblieferungWrite = 12,
  BestandRead = 13,
  BestandWrite = 14,
  NachweisRead = 15,
  Cockpit = 16,
  Report = 17,
  ImportInbound = 18,
  ImportOutbound = 19,
  ZertifikatRead = 20,
  ZertifikatWrite = 21,
  BilanzRead = 22,
  BilanzWrite = 23,
  PocRead = 24,
  GenericImport = 25,
  Nachweisverteilung = 26,
  Nachweisverfolgung = 27,
  YtdReport = 28,
  MandantAllgemeinRead = 29,
  MandantAllgemeinWrite = 30,
  ZertifizierungenRead = 31,
  ZertifizierungenWrite = 32
}

export interface BenutzerBerechtigung {
  typ: number;
  hasPermission: boolean;
}

export interface RolleInfo {
  id: number;
  name: string;
}

export interface PermissionGroup {
  name: string;
  displayName: string;
  readPermission: number;
  writePermission: number;
}

export interface UserPermissionInfo {
  permissions: BenutzerBerechtigung[];
  roles: RolleInfo[];
  isSystemAdmin: boolean;
  isMandantAdmin: boolean;
}
